module.exports = __webpack_public_path__ + "img/ISL.f88928bf.svg";